'use strict';

const { addClass, removeClass, hasClass } = require('../domUtil');
const { KBD_CLASS } = require('../constants');

module.exports = function initInputModalityToggle() {
    const body = document.body;
    if (!body) {
        return;
    }

    window.__lastWasKeyboard = false;

    function enableKeyboardMode() {
        window.__lastWasKeyboard = false;
        addClass(body, KBD_CLASS);
    }

    function disableKeyboardMode() {
        window.__lastWasKeyboard = true;
        removeClass(body, KBD_CLASS);
    }

    window.addEventListener('keydown', function () {
        enableKeyboardMode();
    }, true);

    window.addEventListener('mousedown', function () {
        disableKeyboardMode();
    }, true);

    window.addEventListener('pointerdown', function () {
        disableKeyboardMode();
    }, true);

    window.addEventListener('touchstart', function () {
        disableKeyboardMode();
    }, {
        capture: true,
        passive: true
    });

    window.addEventListener('mousemove', function () {
        disableKeyboardMode();
    }, true);

    window.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'mouse') {
            disableKeyboardMode();
        }
    }, true);
};
